import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable({ providedIn: 'root' })
export class CustomPaginatorIntl extends MatPaginatorIntl {
    getRangeLabel = (page: number, pageSize: number, length: number) => {
        return `${(page * pageSize) + 1} – ${Math.min((page + 1) * pageSize, length)}`;
    };
}